export default __webpack_public_path__ + "static/media/product3.b62ec5e5.jpg";